// extracted by mini-css-extract-plugin
module.exports = {"header":"components-base-Header-Header__header--11FSR"};